import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import rootReducer from './slices';
import rootSaga from './saga';
import { importPromptsStart } from './slices/promptsSlice';
import { importLeadersCsvStart } from './slices/leadersSlice';
import { importAssessmentsStart } from './slices/assessmentsSlice';

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            thunk: false,
            serializableCheck: {
                ignoredActions: [
                    importPromptsStart.type,
                    importLeadersCsvStart.type,
                    importAssessmentsStart.type,
                ],
            },
        }).concat(sagaMiddleware),
    devTools: process.env.NODE_ENV !== 'production',
});

sagaMiddleware.run(rootSaga);

export default store;